import { Controller } from "@hotwired/stimulus"

// Debounced search form - submits on input after delay, or on Enter.
// Shows a loading spinner in the search icon while the turbo frame is fetching.
export default class extends Controller {
  static targets = ["form", "query", "icon", "spinner"]
  static values = { delay: { type: Number, default: 800 } }

  connect() {
    this.timeout = null
    this._onFrameLoad = this.stopLoading.bind(this)
    document.addEventListener("turbo:frame-load", this._onFrameLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this._onFrameLoad)
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.submit()
    }, this.delayValue)
  }

  submit() {
    if (this.hasFormTarget) {
      this.startLoading()
      this.dispatch("submit", { target: document })
      this.formTarget.requestSubmit()
    }
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      clearTimeout(this.timeout)
      this.submit()
    }
  }

  startLoading() {
    if (this.hasIconTarget) this.iconTarget.classList.add("hidden")
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
  }

  stopLoading() {
    if (this.hasIconTarget) this.iconTarget.classList.remove("hidden")
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
  }
}
